import React from 'react';
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { setAuthLoaded, setAuthToken, setAuthDealer } from '../../../../redux/actions';

class LogoutScreen extends React.Component {

    componentDidMount() {
        // Clear from store and force clear from local storage to remove "Remember me!" setting
        this.props.setAuthDealer(null, true);
        this.props.setAuthToken('', true);
        this.props.setAuthLoaded(false);
    }

    render() {
        return <Redirect to="/user/login" />;
    }

}

const mapDispatchToProps = dispatch => {
    return {
        setAuthDealer: (value, remember) => dispatch(setAuthDealer(value, remember)),
        setAuthToken: (value, remember) => dispatch(setAuthToken(value, remember)),
        setAuthLoaded: (value) => dispatch(setAuthLoaded(value)),
    };
};

export default connect(
    null,
    mapDispatchToProps
)(LogoutScreen);
